(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LmLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lm-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        tooltip.classList.remove('show')
        tooltip.classList.add('hiding')
        setTimeout(() => {
          tooltip.classList.remove('hiding')
        }, 200);
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', LmLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rypple-22-professionals"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';

  const loadKey = '__ryppleProfessionalsLoaded';
  if (window[loadKey]) return;
  window[loadKey] = true;
  const instances = new Map();
  const interval = 5000;

  function init(root) {
    if (instances.has(root)) return;
    const slides = Array.from(root.querySelectorAll('[data-rp-pro-slide]'));
    const viewport = root.querySelector('[data-rp-pro-viewport]');
    const listeners = new AbortController();
    const { signal } = listeners;
    const loads = new WeakMap();
    const failed = new Set();
    const benefits = Array.from(root.querySelectorAll('[data-rp-pro-benefit-toggle]')).map(button => {
      const article = button.closest('[data-rp-pro-benefit]');
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      return article && panel && article.contains(panel) ? { button, article, panel } : null;
    }).filter(Boolean);
    let active = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
    let timer = 0;
    let disposed = false;
    let ready = false;
    let priming = false;
    let waiting = false;
    let near = !('IntersectionObserver' in window);
    let visible = near;
    let visibilityObserver;
    let preloadObserver;

    function setBenefit(benefit, open) {
      benefit.article.classList.toggle('is-open', open);
      benefit.button.setAttribute('aria-expanded', String(open));
      benefit.panel.setAttribute('aria-hidden', String(!open));
      benefit.panel.inert = !open;
    }

    benefits.forEach(benefit => {
      setBenefit(benefit, false);
      benefit.button.addEventListener('click', () => {
        const open = benefit.button.getAttribute('aria-expanded') !== 'true';
        benefits.forEach(item => setBenefit(item, item === benefit && open));
      }, { signal });
    });

    function canRun() {
      return ready && !disposed && root.isConnected && visible && !document.hidden &&
        slides.length - failed.size > 1;
    }

    function stopTimer() {
      clearTimeout(timer);
      timer = 0;
      root.dataset.rpProAutoplay = 'paused';
    }

    function nextAvailable(from = active) {
      for (let step = 1; step < slides.length; step += 1) {
        const index = (from + step) % slides.length;
        if (!failed.has(index)) return index;
      }
      return from;
    }

    function loadImage(image) {
      if (loads.has(image)) return loads.get(image);
      const promise = new Promise(resolve => {
        let finished = false;
        let decoding = false;
        function complete(success) {
          if (finished) return;
          finished = true;
          image.removeEventListener('load', loaded);
          image.removeEventListener('error', errored);
          signal.removeEventListener('abort', aborted);
          resolve(success);
        }
        function loaded() {
          if (decoding || finished) return;
          if (!image.naturalWidth) { complete(false); return; }
          decoding = true;
          if (image.decode) image.decode().then(() => complete(true), () => complete(image.naturalWidth > 0));
          else complete(true);
        }
        function errored() { complete(false); }
        function aborted() { complete(false); }
        image.addEventListener('load', loaded);
        image.addEventListener('error', errored);
        signal.addEventListener('abort', aborted, { once: true });
        image.decoding = 'async';
        image.loading = 'eager';
        if (image.dataset.sizes) image.sizes = image.dataset.sizes;
        if (image.dataset.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src) image.src = image.dataset.src;
        if (image.complete && image.naturalWidth) loaded();
        else if (image.complete && image.getAttribute('src')) complete(false);
        else if (!image.currentSrc && !image.getAttribute('src') && !image.getAttribute('srcset')) complete(false);
      });
      loads.set(image, promise);
      return promise;
    }

    async function ensureSlide(index) {
      const image = slides[index].querySelector('img');
      const loaded = image ? await loadImage(image) : true;
      if (disposed) return false;
      if (loaded) slides[index].classList.add('is-ready');
      else failed.add(index);
      return loaded;
    }

    function render() {
      slides.forEach((slide, index) => {
        const selected = index === active;
        slide.classList.toggle('is-active', selected);
        slide.setAttribute('aria-hidden', String(!selected));
        slide.inert = !selected;
      });
    }

    function preloadNext() {
      if (disposed || !ready || !near || document.hidden || slides.length < 2) return;
      const next = nextAvailable();
      if (next !== active) void ensureSlide(next);
    }

    function schedule() {
      stopTimer();
      if (waiting || !canRun()) return;
      root.dataset.rpProAutoplay = 'running';
      timer = window.setTimeout(advance, interval);
    }

    async function advance() {
      stopTimer();
      if (!canRun()) return;
      waiting = true;
      let next = nextAvailable();
      while (next !== active && canRun()) {
        const loaded = await ensureSlide(next);
        if (disposed) return;
        if (loaded) {
          if (canRun()) {
            active = next;
            render();
            preloadNext();
          }
          break;
        }
        next = nextAvailable();
      }
      waiting = false;
      schedule();
    }

    async function prime() {
      if (disposed || ready || priming || document.hidden || !near || !slides.length) return;
      priming = true;
      let next = active;
      while (!disposed && failed.size < slides.length) {
        if (await ensureSlide(next)) {
          active = next;
          ready = true;
          render();
          break;
        }
        next = nextAvailable(next);
      }
      priming = false;
      if (disposed) return;
      preloadNext();
      schedule();
    }

    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        void prime();
        preloadNext();
      }
      schedule();
    }, { signal });

    if (viewport && 'IntersectionObserver' in window) {
      preloadObserver = new IntersectionObserver(entries => {
        near = entries.some(entry => entry.isIntersecting);
        if (near) {
          void prime();
          preloadNext();
        }
      }, { rootMargin: '300px 0px' });
      preloadObserver.observe(viewport);
      visibilityObserver = new IntersectionObserver(entries => {
        visible = entries.some(entry => entry.isIntersecting && entry.intersectionRatio >= 0.2);
        if (visible) {
          near = true;
          void prime();
        }
        schedule();
      }, { threshold: [0, 0.2] });
      visibilityObserver.observe(viewport);
    } else {
      near = true;
      visible = true;
      void prime();
    }

    function cleanup() {
      if (disposed) return;
      disposed = true;
      stopTimer();
      listeners.abort();
      visibilityObserver?.disconnect();
      preloadObserver?.disconnect();
      benefits.forEach(benefit => setBenefit(benefit, true));
      root.classList.remove('is-ready');
      instances.delete(root);
    }

    render();
    root.classList.add('is-ready');
    instances.set(root, cleanup);
  }

  function initWithin(scope) {
    if (scope.matches?.('[data-rp-professionals]')) init(scope);
    scope.querySelectorAll('[data-rp-professionals]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else initWithin(document);
  document.addEventListener('shopify:section:load', event => initWithin(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, root) => {
      if (event.target === root || event.target.contains(root)) cleanup();
    });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
